import React from 'react'
import { Box } from 'theme-ui'
import PoweredByGatsby from '@components/PoweredByGatsby'
import { HeaderLogo } from '../Header/Header.Logo'
import { FcLike } from "react-icons/fc";
import { Link } from 'theme-ui'

const styles = {
  logo: {
    pb: 1,
    mb: 2,
    mt: [4, 0]
  },
  copyright: {
    pt: 2,
    mb: [2, 4]
  },
  link: {
    display: `inline-flex`,
    color: `heading`,
    fontWeight: `medium`,
    ':visited': {
      color: `heading`
    }
  }
}

export const FooterLogo = () => (
  <>
    <Box sx={styles.logo}>
      <HeaderLogo grayscale />
    </Box>
    <Box sx={styles.copyright}>
      © {new Date().getFullYear()}, Réalisé avec <FcLike /> par <b>
        <Link
          variant='mute'
          target='_blank'
          title='Evostar'
          href='/author/evostar/'
          rel='noopener'
          sx={styles.link}
        >Evostar</Link></b>
    </Box>
    <Box>
      <PoweredByGatsby />
    </Box>
  </>
)
